export const DESKTOP_TEXT_WIDTH = 350;
